import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { Secret } from "../../schema/types/secret/entity";
import { linksOf } from "../../services/cpln";
import { SecretTypeColumn } from "../../newcomponents/table/columns/secret/typeColumn";
import { TableActionsDropdown } from "../../newcomponents/table/components/tableActionsDropdown";
import { DeleteModal } from "../../components/modals/deleteModal";
import { Query } from "../../schema/types/query/query";
import { Checkbox } from "antd";
import {
  getSecretTableItem,
  SecretTableItem,
  STORAGE_KEY_SECRET_LIST_HIDE_HELM_STATE,
} from "../../mst/kinds/secret.helpers";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";

export const SecretList: React.FC = () => {
  const [selectedLinks, setSelectedLinks] = React.useState<string[]>([]);
  const [action, setAction] = React.useState<string>("");

  function getDefaultHideHelmState() {
    const localValue = localStorage.getItem(STORAGE_KEY_SECRET_LIST_HIDE_HELM_STATE);
    if (!localValue) {
      return true;
    }
    return localValue === "true" ? true : false;
  }
  const [hideHelmState, setHideHelmState] = React.useState(getDefaultHideHelmState());
  React.useEffect(() => {
    localStorage.setItem(STORAGE_KEY_SECRET_LIST_HIDE_HELM_STATE, String(hideHelmState));
  }, [hideHelmState]);

  const helmStateQuery: Query = React.useMemo(
    () => ({
      kind: "secret",
      spec: {
        match: "none",
        terms: [
          {
            property: "name",
            op: "~",
            value: "cpln-helm-release",
          },
          {
            property: "name",
            op: "~",
            value: "cpln-release",
          },
          {
            tag: "cpln/helm",
            op: "=",
            value: "true",
          },
        ],
      },
    }),
    [],
  );
  const query = hideHelmState ? helmStateQuery : undefined;

  const { kind, id } = useTableKindId("secret", "secret-list");
  const qData = useTableItemQueryData<Secret>(kind, { query: query });
  const columns = useColumnsWithTagColumns<SecretTableItem>(
    [NameDescriptionColumn(), SecretTypeColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()],
    kind,
  );

  const secretTableItems = qData.visibleItems.map((item) => getSecretTableItem({ item: item }));

  return (
    <>
      <Table<SecretTableItem>
        title={"Secrets"}
        data={secretTableItems}
        selectKey="selfLink"
        selectMode="multi"
        selections={selectedLinks}
        onSelectionsChange={setSelectedLinks}
        tableId={id}
        headerRenderer={() => {
          return (
            <>
              <Checkbox
                disabled={!!qData.query}
                checked={!!qData.query ? false : hideHelmState}
                onChange={(e) => setHideHelmState(e.target.checked)}
              >
                Hide Helm State Secrets
              </Checkbox>
              <TableNewItemButton kind={kind} />
              <TableActionsDropdown
                kind={kind}
                selectionLinks={selectedLinks}
                options={[
                  {
                    key: "delete",
                    label: "Delete",
                    disabled: selectedLinks.length < 1,
                    danger: true,
                    callback: () => setAction("delete"),
                  },
                ]}
              />
              <TableHeaderRefreshButton onClick={qData.refetch} />
              <CustomTableCPLNQuery
                tableId={id}
                kind={kind}
                onQuery={qData.setCplnQuery}
                isLoading={qData.isLoading}
              />
            </>
          );
        }}
        enableFilter
        isLoading={qData.isLoading}
        onSortChange={qData.setSort}
        onSearchChange={qData.setSearch}
        isLoadingMore={qData.isLoadingMore}
        hasMore={qData.hasMore}
        onLoadMore={qData.fetchNextPage}
        columns={columns}
      />
      {action === "delete" ? (
        <DeleteModal
          kind={kind}
          onCancel={() => setAction("")}
          onComplete={() => {
            setAction("");
            setSelectedLinks([]);
            qData.refetch();
          }}
          links={selectedLinks}
        />
      ) : null}
    </>
  );
};
